import { createSlice, createAction } from "@reduxjs/toolkit";
import { loginThunk } from "../thunks/authThunk";

const loginInitialState = {
  accessToken: null,
  employeeId: null,
  name: null,
  role: null,
  expiresIn: null,
  loading: false,
  error: null,
  mobile: null,
};

export const logoutAndResetStore = createAction(
  "auth/logoutAndResetStore"
);

export const authSlice = createSlice({
  name: "auth",
  initialState: loginInitialState,

  reducers: {
    logout() {
      return loginInitialState;
    },
  },

  extraReducers: (builder) => {
    builder
      // Login Pending
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      // Login Success
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        state.accessToken = action.payload.accessToken;
        state.employeeId = action.payload.employeeId;
        state.name = action.payload.name;
        state.role = action.payload.role;
        state.expiresIn = action.payload.expiresIn;
        state.mobile = action.payload.mobile;
      })

      // Login Failed
      .addCase(loginThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
      })

      // Logout
      .addCase(logoutAndResetStore, () => loginInitialState);
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;